export const reportSections = [
    {level: 0, name: 'Introduction'},
    {level: 1, name: 'Horticulture & Ecology'},
    {level: 2, name: 'Water Conservation'},
    {level: 3, name: 'Zero Waste Planning'},
    {level: 4, name: 'Energy & Emissions'},
    {level: 5, name: 'Glossary'},
]

export const reports = [
    '0_Introduction/Introduction.pdf',
    '1_Horticulture & Ecology/Organic Land Management.pdf',
    '1_Horticulture & Ecology/Soil Management.pdf',
    '1_Horticulture & Ecology/Tree and Vegetation Protection.pdf',
    '1_Horticulture & Ecology/Smart Turf Management.pdf',
    '1_Horticulture & Ecology/Urban Forestry and Restoration Ecology.pdf',
    '1_Horticulture & Ecology/Plant Procurement.pdf',
    '2_Water Conservation/Water-Efficient Buildings.pdf',
    '2_Water Conservation/Greywater and Reclaimed Water Reuse.pdf',
    '2_Water Conservation/Smart Irrigation & Xeriscaping.pdf',
    '2_Water Conservation/Sustainable Pool Management.pdf',
    '2_Water Conservation/Environmentally Friendly Cleaning Products.pdf',
    '3_Zero Waste Planning/Diverted Stream Waste Management.pdf',
    '3_Zero Waste Planning/Circular Economy.pdf',
    '3_Zero Waste Planning/Green Waste & Biomass Management.pdf',
    '4_Energy & Emissions/Enhance Energy Efficiency in Buildings.pdf',
    '4_Energy & Emissions/Renewable Energy Production.pdf',
    '4_Energy & Emissions/Third-Party Renewable Energy.pdf',
    '4_Energy & Emissions/Lighting.pdf',
    '4_Energy & Emissions/Maintenance Equipment.pdf',
    '4_Energy & Emissions/Reducing Embodied Carbon.pdf',
    '4_Energy & Emissions/Carbon Capture Technologies.pdf',
    '4_Energy & Emissions/Microgrids.pdf',
    '4_Energy & Emissions/Energy Modeling, Commissioning, and Tracking.pdf',
    '5_Glossary/Glossary.pdf',

];

function extractReportStructure(filename) {
    // Remove .pdf extension (case-insensitive)
    const base = filename.replace(/\.pdf$/i, "");

    // Match pattern: number_folder/filename
    const match = base.match(/^(\d+)_([^/]+)\/(.+)$/);
    if (!match) {
        // fallback: return only the name
        return [undefined, undefined, base];
    }

    const [, numberStr, folder, name] = match;
    return [parseInt(numberStr, 10), folder.trim(), name.trim()];
}

export const reportStrategies = {};

for (const reportName of reports) {
    const [primary, secondary, name] = extractReportStructure(reportName);
    const cat = reportSections.find(s => s.level === primary)?.name || 'Resources';
    if (!reportStrategies[cat]) reportStrategies[cat] = {displayName: cat, reports: []};
    reportStrategies[cat].reports.push({number: secondary, name, pdfName: reportName});
}
